import React from 'react';
import {Route} from 'react-router-dom';
import {Wrapper} from '../hooks/common';
import {Create, List} from '../hooks/customdeliverycost/';

export default [
  <Route path="/custom_delivery_costs/create/:idPurchaser" component={props => <Wrapper component={Create} {...props} />} exact key="custom-delivery-cost-create" />,
  <Route path="/custom_delivery_costs/:idPurchaser" component={props => <Wrapper component={List} {...props} />} exact strict key="custom-delivery-costs-list" />,
];